import React, { useMemo } from "react";
import { useTranslationV3 } from "../../i18nV3/useTranslationV3";
import { SmallText, Title, Text } from "./components/Typography";
import { CancellationProposal } from "../../types/Cancellation";
import styled from "styled-components";
import FlightBounds from "./components/FlightBounds";
import { getBoundsFromCancellationProposal } from "../../services/cancellationProposalService";

interface Props {
  cancellationProposal: CancellationProposal;
}

const AlreadyConfirmedView = ({ cancellationProposal }: Props) => {
  const { t } = useTranslationV3();
  const bounds = useMemo(
    () => getBoundsFromCancellationProposal(cancellationProposal),
    [cancellationProposal]
  );

  return (
    <>
      <Title>{t("lp_cancellation_already_confirmed_title")}</Title>
      <Subtitle>{t("lp_cancellation_already_confirmed_content")}</Subtitle>
      <TripIdIndicator>
        {t("lp_cancellation_trip_id", { tripId: cancellationProposal.tripId })}
      </TripIdIndicator>
      <FlightBounds bounds={bounds} isCancelled />
    </>
  );
};

const Subtitle = styled(Text)`
  margin-bottom: 22px;
`;

const TripIdIndicator = styled(SmallText)`
  text-align: right;
  margin-bottom: 10px;
`;

export default AlreadyConfirmedView;
